import { useState } from "react";
import { getCurrentTimeInUserTZ } from "../services/application-service";

export default function useRealTimeDuration({
    duration,
    defaultState = true
}: {
    duration: { fromTime: string, toTime: string },
    defaultState?: boolean
}) {
    const [realtime, setRealtime] = useState(defaultState);

    const handleClickRealTime = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRealtime(event.target.checked);
    };

    function getDuration() {
        let newDuration = { ...duration };
        if (newDuration && realtime) {
            newDuration.toTime = getCurrentTimeInUserTZ();
            newDuration.fromTime = newDuration.toTime.split(' ')[0] + ' 00:00:00';
        }
        return newDuration;
    }

    return { realtime, handleClickRealTime, getDuration };
}
